






































































import Vue from "vue";
import {
  ref,
  defineComponent,
  computed,
  onMounted
} from "@vue/composition-api";
import { useGetters, useActions } from "vuex-composition-helpers";
import PrimaryContentBody from "@/vue/layouts/PrimaryContentBody.vue";

import { useInputRules } from "@/ts/functions/composition/inputRules";

export default defineComponent({
  name: "Login",

  components: {
    PrimaryContentBody
  },

  setup(props, { root, refs }) {
    onMounted(() => {
      root.$store.commit("app/setErrors", {});
    });

    const rules = {
      email: useInputRules().email,
      required: useInputRules().required,
      min: useInputRules().min
    };

    var { SEND_LOGIN_REQUEST } = useActions({
      SEND_LOGIN_REQUEST: "auth/SEND_LOGIN_REQUEST"
    } as any);
    var { errors } = useGetters({ errors: "app/errors" } as any);
    var { verifying } = useGetters({ verifying: "auth/verifying" } as any);

    var valid = ref(false);
    var show_password = ref(false);
    var loading = ref(false);
    var form = ref({
      password: "",
      email: ""
    });

    const refForm = computed(
      () => refs.loginForm as Vue & { validate: () => boolean }
    );

    const login = () => {
      if (refForm.value.validate()) {
        loading.value = true;
        SEND_LOGIN_REQUEST(form.value)
        .then(() => {
            if (verifying.value) {
              window.location.href = "/verify/" + verifying.value;
            } else {
              window.location.href = '/';
              //root.$router.push({ name: "Home" }).catch(() => {});
            }
          })

          .catch(() => {
            loading.value = false;
          });
      }
    };

    return {
      errors,
      valid,
      show_password,
      loading,
      form,
      rules,
      refForm,
      login,
      verifying
    };
  }
});
